import React from "react";
import Button from "./button";
import { rawTheme } from "styles/theme";
import { makeStyles } from "@material-ui/styles";
import color from "color";

const useStyles = makeStyles({
    rightWrapper: {
        float: "right",
        marginRight: "10px",
        position: "relative",
    },
    buttonWrapper: {
        display: "inline-block",
    },
    button: {
        padding: "0px 0px !important",
        justifyContent: "center",
        alignItems: "center",
        gap: "var(--spacing-2, 8px)",
        borderRadius: "4px !important",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: "bold",
        lineHeight: "20px",
        border: (props: any) =>
            !props?.primary && props?.disabled ? `1px solid ${rawTheme.palette.lighterGrey}` : "inherit",
        "& span": {
            padding: "inherit !important",
            verticalAlign: "inherit !important",
            fontWeight: "inherit !important",
            color: "inherit !important",
        },
    },
    primaryButton: {
        marginRight: "5px",
        background: (props: any) =>
            props?.disabled
                ? color(rawTheme.palette.darkMint).desaturate(0.4).lighten(0.4).rgbString()
                : `${rawTheme.palette.darkMint} !important`,
        color: `${rawTheme.palette.white} !important`,
    },
    secondaryButton: {
        marginRight: "10px !important",
        background: `${rawTheme.palette.white} !important`,
        color: `${rawTheme.palette.textColor} !important`,
    },
    outlineButton: {
        color: `${rawTheme.palette.darkMint} !important`,
        background: `${rawTheme.palette.white} !important`,
        border: "none !important",
    },
    disabled: {
        backgroundColor: "light-dark(rgba(239, 239, 239, 0.3), rgba(19, 1, 1, 0.3))",
        color: "light-dark(rgba(16, 16, 16, 0.3), rgba(255, 255, 255, 0.3))",
        borderColor: "light-dark(rgba(118, 118, 118, 0.3)",
    },
});

const ActionButton: React.FC<any> = (props) => {
    const classes = useStyles(props);
    const { primary = false, outline = false, styles = {}, type = "submit", disabled = false, ...rest } = props;
    const selectedClass = primary ? classes.primaryButton : outline ? classes.outlineButton : classes.secondaryButton;
    return (
        <Button
            type={type}
            primary={primary}
            disabled={disabled}
            {...rest}
            className={`${classes.button} ${selectedClass}`}
            style={{ ...styles, fontWeight: "bold !important" }}
        />
    );
};

export default ActionButton;
